$(function(){
	Contents();
});


function Contents(){
	runSwiper('.inslider','scroll',16,2000,750);
	if($(window).width()<=768){
		runSwiper('.spslider','fade',0,3000,500);
	}
}
function runSwiper($myTarget,$effect,$space,$dur,$speed){
	/*
	var swiperThumbs = new Swiper($myThumb, {
		loop: false,
		spaceBetween: 10,
		slidesPerView: 3,
		watchSlidesProgress: false,
		direction: 'horizontal',
		breakpoints: {
			768: {
				direction: 'vertical',
			},
		},
	});
	*/
	var $mySwiper = new Swiper ($myTarget, {
		/*
		pagination: {
			el: '.pager',
			clickable: true,
		},
		navigation: {
			nextEl: $myNext,
			prevEl: $myPrev,
			clickable: true,
		},		
		*/
		loop: true,
		effect: $effect,
		speed: $speed,
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: $space,
		autoplay: {
			duration: $dur,
		},		
		/*thumbs: {
			swiper: swiperThumbs,
		},*/
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 40
			},
		},
	});	
}

function myScroll(){
	$('.pgtop').on('click', function(){
		$('html,body').stop().animate({scrollTop:(0)}, 1000, 'easeOutQuad');
		return false;
	});
}